
import React from 'react'

import EditAdForm from '../../modules/Ad/components/EditAdForm'
export default function EditAdPage() {
  return <EditAdForm />
}